import { render, staticRenderFns } from "./workerEdu.vue?vue&type=template&id=65005a5a&scoped=true&"
import script from "./workerEdu.vue?vue&type=script&lang=js&"
export * from "./workerEdu.vue?vue&type=script&lang=js&"
import style0 from "./workerEdu.vue?vue&type=style&index=0&id=65005a5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65005a5a",
  null
  
)

export default component.exports